import { IWeekWorkTime } from 'features/working-hours-picker/interfaces/time-table-input.interface';
import { WeekDaysArray } from 'shared/consts/calendar.consts';
export const workingDayTimeHandler = (
  dayWorkTime: { start: string; end: string } | undefined,
  weekWorkTime: IWeekWorkTime | null | undefined
) => {
  if (!dayWorkTime || !weekWorkTime) {
    return 'Время работы не указано';
  }

  const now = new Date();
  const jsDayIndex = now.getDay(); // 0 (вс) - 6 (сб)
  const correctedDayIndex = jsDayIndex === 0 ? 6 : jsDayIndex - 1;
  const currentTime = now.getHours() * 60 + now.getMinutes();

  const parseTime = (time: string) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const getDayName = (dayIndex: number): string => {
    const days = WeekDaysArray.map((day: string) => day.toLowerCase());
    return days[dayIndex];
  };

  // Проверяем, открыто ли сейчас
  if (dayWorkTime.start !== null && dayWorkTime.end !== null) {
    // Если круглосуточно
    if (dayWorkTime.start === '00:00' && dayWorkTime.end === '00:00') {
      return 'Открыто круглосуточно';
    }

    const startTime = parseTime(dayWorkTime.start);
    const endTime = parseTime(dayWorkTime.end);

    // Если сейчас рабочее время
    if (currentTime >= startTime && currentTime < endTime) {
      return `Открыто до ${dayWorkTime.end}`;
    }

    // Если сегодня еще будет открыто (время сейчас раньше времени открытия)
    if (currentTime < startTime) {
      return `Закрыто до ${dayWorkTime.start}`;
    }
  }

  // Если сегодня выходной или уже закрыто, ищем следующий рабочий день
  const getNextWorkingDay = (currentDay: number) => {
    for (let i = 1; i <= 7; i++) {
      const nextDay = (currentDay + i) % 7;
      const nextDayKey = Object.keys(weekWorkTime)[
        nextDay
      ] as keyof typeof weekWorkTime;
      const nextDayTimeRange = weekWorkTime[nextDayKey];

      if (nextDayTimeRange.start !== null && nextDayTimeRange.end !== null) {
        return {
          nextDay,
          nextDayTimeRange,
          daysUntilOpen: i,
          dayName: getDayName(nextDay),
          isAllDay:
            nextDayTimeRange.start === '00:00' &&
            nextDayTimeRange.end === '00:00',
        };
      }
    }
    return null;
  };

  const nextWorkingDay = getNextWorkingDay(correctedDayIndex);
  if (!nextWorkingDay) return 'Закрыто на неопределённый срок';

  if (nextWorkingDay.isAllDay) {
    if (nextWorkingDay.daysUntilOpen > 1) {
      return `Закрыто до ${nextWorkingDay.dayName} (круглосуточно)`;
    } else {
      return 'Закрыто до завтра (круглосуточно)';
    }
  } else {
    if (nextWorkingDay.daysUntilOpen > 1) {
      return `Закрыто до ${nextWorkingDay.dayName} ${nextWorkingDay.nextDayTimeRange.start}`;
    } else {
      return `Закрыто до ${nextWorkingDay.nextDayTimeRange.start}`;
    }
  }
};
